import { Component, OnInit, Input } from '@angular/core';
import { LogCategory, LogType, LoggerService, LogPage } from 'src/app/core/services/logger.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ProfileService } from 'src/app/core/services/profile.service';
import { TagManagerService } from '../../../core/services/tag-manager.service';

@Component({
    selector: 'app-people-download-buttons',
    templateUrl: './people-download-buttons.component.html',
    styleUrls: ['./people-download-buttons.component.scss'],
    standalone: false
})

export class PeopleDownloadButtonsComponent implements OnInit {
       
    @Input() sectionId: number;   
    
    constructor(private logger: LoggerService,
        public profileService: ProfileService,        
        private gtm: TagManagerService) {
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Page, LogPage.PeopleDownload, category);
    }

    ngOnInit(): void {
        this.log("ngOnInit", null, LogCategory.Init);        
    }

    public downloadCsv() {
        //log to ga
        this.gtm.gaDownload('Roster');                
        //  This should be a finite observable so the subscribe shouldn't cause a memory leak
        this.profileService.downloadRoster$(this.sectionId).subscribe();
    }

    public downloadBiobooks() {
        //log to ga
        this.gtm.gaDownload('BioBook');        
        this.profileService.getBiobook(this.sectionId);        
    }
}
